import { Optional } from './index.js';
const sleepInMilliseconds = (props) => {
    return new Promise((resolve) => {
        return setTimeout(async () => {
            const value = Optional.from(await props.callback?.());
            resolve(value);
        }, props.milliseconds);
    });
};
const sleepInSeconds = (props) => {
    return sleepInMilliseconds({
        milliseconds: props.seconds * 1000,
        callback: props.callback,
    });
};
const sequentialPromise = (promises) => {
    return promises.reduce(async (previousPromise, currentPromise) => {
        return previousPromise.then(async (previousResult) => {
            return previousResult.concat(await currentPromise());
        });
    }, Promise.resolve([]));
};
export { sleepInMilliseconds, sleepInSeconds, sequentialPromise };
//# sourceMappingURL=promise.js.map